import { render, staticRenderFns } from "./NaviGation_VideoSound.vue?vue&type=template&id=6c1823c2&scoped=true"
import script from "./NaviGation_VideoSound.vue?vue&type=script&lang=js"
export * from "./NaviGation_VideoSound.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_VideoSound.vue?vue&type=style&index=0&id=6c1823c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1823c2",
  null
  
)

export default component.exports